/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentLocation_development$ref: FragmentReference;
declare export opaque type DevelopmentLocation_development$fragmentType: DevelopmentLocation_development$ref;
export type DevelopmentLocation_development = {|
  +products: $ReadOnlyArray<{|
    +property: {|
      +lat: ?number,
      +lng: ?number,
      +locality: ?string,
      +postcode: ?string,
      +route: ?string,
      +streetNumber: ?string,
    |}
  |}>,
  +$refType: DevelopmentLocation_development$ref,
|};
export type DevelopmentLocation_development$data = DevelopmentLocation_development;
export type DevelopmentLocation_development$key = {
  +$data?: DevelopmentLocation_development$data,
  +$fragmentRefs: DevelopmentLocation_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentLocation_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lng",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "locality",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postcode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "route",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "streetNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4e8d2032e4b2c9c1b6c8813f0177f9ee';

export default node;
